import * as React from 'react';
import { cn } from '@utils';

export const CenteredLayout = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div
			ref={ref}
			className={cn('flex h-full flex-col items-center justify-center text-center grow', className)}
			data-aid="center-layout"
			data-testid="centered-layout"
			{...props}
		/>
	)
);
CenteredLayout.displayName = 'CenteredLayout';
